var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0.8 3.4 C 1.319 3.01 1.951 2.799 2.6 2.8 L 13.4 2.8 C 14.075 2.8 14.698 3.023 15.2 3.4 C 15.2 2.406 14.394 1.6 13.4 1.6 L 2.6 1.6 C 1.606 1.6 0.8 2.406 0.8 3.4 Z M 0.8 5.8 C 1.319 5.41 1.951 5.199 2.6 5.2 L 13.4 5.2 C 14.075 5.2 14.698 5.423 15.2 5.8 C 15.2 4.806 14.394 4 13.4 4 L 2.6 4 C 1.606 4 0.8 4.806 0.8 5.8 Z M 5.6 6.4 C 6.042 6.4 6.4 6.758 6.4 7.2 C 6.4 8.084 7.116 8.8 8 8.8 C 8.884 8.8 9.6 8.084 9.6 7.2 C 9.6 6.758 9.958 6.4 10.4 6.4 L 13.4 6.4 C 14.394 6.4 15.2 7.206 15.2 8.2 L 15.2 12.6 C 15.2 13.594 14.394 14.4 13.4 14.4 L 2.6 14.4 C 1.606 14.4 0.8 13.594 0.8 12.6 L 0.8 8.2 C 0.8 7.206 1.606 6.4 2.6 6.4 Z",
    fill: "rgb(179, 179, 179)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.11eb16975e4414890cba07749917accf.svg";
export { ForwardRef as ReactComponent };